(function () {
  function getHeaderOffset() {
    var stickyHeader = document.querySelector('.header-sticky--active');
    if (!stickyHeader) return 0;

    var cssHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if (!Number.isNaN(cssHeight) && cssHeight > 0) {
      return cssHeight;
    }

    return stickyHeader.getBoundingClientRect().height;
  }

  function normalizeHash(rawHash) {
    if (!rawHash) return '';
    var clean = String(rawHash).trim().replace(/^#+/, '');
    return clean ? '#' + clean : '';
  }

  function scrollToHash(hash, smooth) {
    var normalizedHash = normalizeHash(hash);
    if (!normalizedHash) return;

    var targetId = normalizedHash.slice(1);
    var decodedTargetId = decodeURIComponent(targetId);
    var target = document.getElementById(targetId) || document.getElementById(decodedTargetId);
    if (!target) return;

    var scrollBuffer = 20;
    var y = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - scrollBuffer;
    var targetY = Math.max(0, y);

    // Let the browser handle the animation natively instead of driving it
    // with a manual requestAnimationFrame loop: a JS-stepped scrollTo() fights
    // the "scroll-behavior: smooth" CSS already set on html/#wrapper (each
    // frame starts its own native tween toward a moving target), which is
    // what caused the shaking/jumping on mobile.
    window.scrollTo({ top: targetY, left: 0, behavior: smooth ? 'smooth' : 'auto' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.se-scroll-link[href^="#"]');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var hash = normalizeHash(link.getAttribute('href'));
    if (!hash) return;
    scrollToHash(hash, true);
  }, true);

  window.addEventListener('load', function () {
    var pageHash = normalizeHash(window.location.hash);
    if (pageHash && document.querySelector('a.se-scroll-link[href="' + pageHash + '"]')) {
      scrollToHash(pageHash, false);
    }
  });

  var kitemarkVariantListenerBound = false;

  function isThirtyThirtyVariant(variant) {
    if (!variant) return false;

    var candidateParts = [];
    if (variant.title) candidateParts.push(String(variant.title));
    if (variant.option1) candidateParts.push(String(variant.option1));
    if (variant.option2) candidateParts.push(String(variant.option2));
    if (variant.option3) candidateParts.push(String(variant.option3));
    if (Array.isArray(variant.options)) {
      for (var i = 0; i < variant.options.length; i += 1) {
        if (variant.options[i]) candidateParts.push(String(variant.options[i]));
      }
    }

    var text = candidateParts.join(" ").toLowerCase();
    return /30\s*(mm)?\s*[-/]\s*30\s*(mm)?/.test(text);
  }

  function isThirtyThirtyFromDom() {
    var selectedValues = document.querySelectorAll('.product-form__option .product-form__selected-value');
    var text = "";

    for (var i = 0; i < selectedValues.length; i += 1) {
      text += " " + (selectedValues[i].textContent || "");
    }

    if (!text.trim()) {
      var checkedInputs = document.querySelectorAll('.product-form input[type="radio"]:checked, .product-form select');
      for (var j = 0; j < checkedInputs.length; j += 1) {
        var el = checkedInputs[j];
        var value = el.tagName === 'SELECT' ? el.options[el.selectedIndex] && el.options[el.selectedIndex].text : el.value;
        text += " " + (value || "");
      }
    }

    return /30\s*(mm)?\s*[-/]\s*30\s*(mm)?/i.test(text);
  }

  function toggleKitemarkBadge(variant) {
    var blocks = document.querySelectorAll('.se-certified-icons-block[data-kitemark-warning-enabled="true"]');
    if (!blocks.length) return;

    var shouldHide = variant ? isThirtyThirtyVariant(variant) : isThirtyThirtyFromDom();
    for (var i = 0; i < blocks.length; i += 1) {
      var grid = blocks[i].querySelector('.se-certified-icons-block__grid');
      if (!grid || !grid.lastElementChild) continue;
      var item = grid.lastElementChild;
      if (!item) continue;
      item.hidden = shouldHide;
    }
  }

  function bindKitemarkVariantBehavior() {
    if (!kitemarkVariantListenerBound) {
      document.addEventListener('product:variant-change', function (event) {
        toggleKitemarkBadge(event && event.detail ? event.detail.variant : null);
      });
      kitemarkVariantListenerBound = true;
    }

    toggleKitemarkBadge(null);
    window.setTimeout(function () {
      toggleKitemarkBadge(null);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindKitemarkVariantBehavior);
  } else {
    bindKitemarkVariantBehavior();
  }
})();
